import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
const plans = [{
  name: 'Startowy',
  price: '129',
  period: 'zł/mies',
  description: 'Essential automation for individuals.',
  features: ['5 Active Assistants', 'Basic Analytics', 'Email Support', '99.5% Uptime'],
  highlight: false
}, {
  name: 'Zaawansowany',
  price: '329',
  period: 'zł/mies',
  description: 'Power tools for growing teams.',
  features: ['25 Active Assistants', 'Real-time Analytics', 'Priority 24/7 Support', '99.9% Uptime', 'Custom Integrations'],
  highlight: true
}, {
  name: 'Korporacyjny',
  price: '749',
  period: 'zł/mies',
  description: 'Full-scale enterprise infrastructure.',
  features: ['Unlimited Assistants', 'Predictive AI Insights', 'Dedicated Account Manager', 'SLA Guarantee', 'On-premise Deployment', 'API Access'],
  highlight: false
}];
export function Pricing() {
  return <section className="py-32 bg-white" data-id="element-60">
      <div className="container mx-auto px-6" data-id="element-61">
        <div className="text-center mb-24" data-id="element-62">
          <h2 className="text-4xl md:text-5xl font-black tracking-tight mb-6" data-id="element-63">
            Transparent Pricing
          </h2>
          <div className="w-24 h-2 bg-[#84cc16] mx-auto" data-id="element-64" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-65">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative p-10 border transition-all duration-300 ${plan.highlight ? 'border-black shadow-2xl scale-105 z-10 bg-white' : 'border-gray-200 hover:border-gray-300 bg-gray-50/50'}`} data-id="element-66">
              {plan.highlight && <div className="absolute top-0 right-0 bg-[#84cc16] text-black text-xs font-bold px-3 py-1 uppercase tracking-wider" data-id="element-67">
                  Recommended
                </div>}

              <h3 className="text-xl font-bold mb-2 tracking-wide uppercase" data-id="element-68">
                {plan.name}
              </h3>
              <div className="flex items-baseline mb-6" data-id="element-69">
                <span className="text-5xl font-black tracking-tighter" data-id="element-70">
                  {plan.price}
                </span>
                <span className="text-gray-500 ml-2 font-medium" data-id="element-71">
                  {plan.period}
                </span>
              </div>
              <p className="text-gray-600 mb-8 min-h-[3rem]" data-id="element-72">
                {plan.description}
              </p>

              <ul className="space-y-4 mb-10" data-id="element-73">
                {plan.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-74">
                    <Check className={`w-5 h-5 mr-3 flex-shrink-0 ${plan.highlight ? 'text-[#84cc16]' : 'text-gray-400'}`} data-id="element-75" />
                    <span className="text-sm font-medium text-gray-800" data-id="element-76">
                      {feature}
                    </span>
                  </li>)}
              </ul>

              <Button variant={plan.highlight ? 'primary' : 'outline'} className="w-full" data-id="element-77">
                Choose {plan.name}
              </Button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}